/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { InvitationCodeEnum } from './invitationCodeEnum';
import { ValidationErrorDetail } from './validationErrorDetail';

/**
 * Serializer for single invitation result in bulk operation.
 */
export interface InvitationResult { 
    /**
     * Email pedagoga
     */
    email: string;
    /**
     * Zda byla pozvánka úspěšně odeslána
     */
    success: boolean;
    invitationCode: InvitationCodeEnum;
    /**
     * Detail chyby (pouze při neúspěchu)
     */
    error?: ValidationErrorDetail;
}